// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/govcon/v1/execution_scope.proto (package mono.govcon.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Struct, Timestamp } from "@bufbuild/protobuf";
import { DocumentBlock, RequestMetadata } from "../../common/v1/types_pb";
import { IntakeSowRequest } from "../../datagateway/v1/contract_model_pb";
import { ExecutionArtifactCompleteness, ExecutionArtifactKind, ExecutionClaimType, ExecutionEvidenceGrade, ExecutionExtractionStatus, ExecutionIdentifierKind, ExecutionIssueSeverity, ExecutionReviewRequirement, ExecutionSourceAnchor, ExecutionSourceUnitCoverageState } from "../../common/v1/execution_scope_pb";
/**
 * ExtractExecutionScopeArtifactRequest is the extractor input contract.
 *
 * @generated from message mono.govcon.v1.ExtractExecutionScopeArtifactRequest
 */ export class ExtractExecutionScopeArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractExecutionScopeArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractExecutionScopeArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractExecutionScopeArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractExecutionScopeArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.RequestMetadata metadata = 1;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string artifact_version_id = 3;
   */ _define_property(this, "artifactVersionId", ""), /**
   * @generated from field: string content_sha256 = 4;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string filename = 5;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 6;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: string program_id = 7;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: repeated string known_contract_identifiers = 8;
   */ _define_property(this, "knownContractIdentifiers", []), /**
   * @generated from field: repeated mono.common.v1.DocumentBlock blocks = 9;
   */ _define_property(this, "blocks", []), /**
   * @generated from field: string extractor_name = 10;
   */ _define_property(this, "extractorName", ""), /**
   * @generated from field: string extractor_version = 11;
   */ _define_property(this, "extractorVersion", ""), /**
   * S8 SOW intake (robin, behind the robin_extraction flag): where the
   * converted document lives, the program's teams and duties it is read
   * against, and the SOW's own team when the caller knows it.
   *
   * @generated from field: string blocks_path = 12;
   */ _define_property(this, "blocksPath", ""), /**
   * @generated from field: string company_id = 13;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string project_id = 14;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string doc_id = 15;
   */ _define_property(this, "docId", ""), /**
   * @generated from field: string workstream_id = 16;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string title = 17;
   */ _define_property(this, "title", ""), /**
   * @generated from field: repeated mono.govcon.v1.SowReadTeam teams = 18;
   */ _define_property(this, "teams", []), /**
   * @generated from field: repeated mono.govcon.v1.SowReadDuty duties = 19;
   */ _define_property(this, "duties", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractExecutionScopeArtifactRequest, "runtime", proto3);
_define_property(ExtractExecutionScopeArtifactRequest, "typeName", "mono.govcon.v1.ExtractExecutionScopeArtifactRequest");
_define_property(ExtractExecutionScopeArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "metadata",
            kind: "message",
            T: RequestMetadata
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "known_contract_identifiers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "blocks",
            kind: "message",
            T: DocumentBlock,
            repeated: true
        },
        {
            no: 10,
            name: "extractor_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "extractor_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "teams",
            kind: "message",
            T: SowReadTeam,
            repeated: true
        },
        {
            no: 19,
            name: "duties",
            kind: "message",
            T: SowReadDuty,
            repeated: true
        }
    ]));
/**
 * SowReadTeam is one program workstream a SOW can name or route to.
 *
 * @generated from message mono.govcon.v1.SowReadTeam
 */ export class SowReadTeam extends Message {
    static fromBinary(bytes, options) {
        return new SowReadTeam().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SowReadTeam().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SowReadTeam().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SowReadTeam, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SowReadTeam, "runtime", proto3);
_define_property(SowReadTeam, "typeName", "mono.govcon.v1.SowReadTeam");
_define_property(SowReadTeam, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SowReadDuty is one award duty a SOW can handle.
 *
 * @generated from message mono.govcon.v1.SowReadDuty
 */ export class SowReadDuty extends Message {
    static fromBinary(bytes, options) {
        return new SowReadDuty().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SowReadDuty().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SowReadDuty().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SowReadDuty, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string key = 2;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string pws_ref = 4;
   */ _define_property(this, "pwsRef", ""), /**
   * @generated from field: string clin = 5;
   */ _define_property(this, "clin", ""), /**
   * @generated from field: int32 optional_task = 6;
   */ _define_property(this, "optionalTask", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SowReadDuty, "runtime", proto3);
_define_property(SowReadDuty, "typeName", "mono.govcon.v1.SowReadDuty");
_define_property(SowReadDuty, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "pws_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "optional_task",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ExtractExecutionScopeArtifactResponse is the extractor output contract.
 *
 * @generated from message mono.govcon.v1.ExtractExecutionScopeArtifactResponse
 */ export class ExtractExecutionScopeArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractExecutionScopeArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractExecutionScopeArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractExecutionScopeArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractExecutionScopeArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.govcon.v1.ExecutionScopeArtifactV1 artifact = 1;
   */ _define_property(this, "artifact", void 0), /**
   * S8: the SOW read as writes, when robin read it (read = true). read is
   * false when the tenant's robin_extraction flag is off; skipped_reason
   * says why nothing was read.
   *
   * @generated from field: mono.datagateway.v1.IntakeSowRequest sow_plan = 2;
   */ _define_property(this, "sowPlan", void 0), /**
   * @generated from field: bool read = 3;
   */ _define_property(this, "read", false), /**
   * @generated from field: string skipped_reason = 4;
   */ _define_property(this, "skippedReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractExecutionScopeArtifactResponse, "runtime", proto3);
_define_property(ExtractExecutionScopeArtifactResponse, "typeName", "mono.govcon.v1.ExtractExecutionScopeArtifactResponse");
_define_property(ExtractExecutionScopeArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: ExecutionScopeArtifactV1
        },
        {
            no: 2,
            name: "sow_plan",
            kind: "message",
            T: IntakeSowRequest
        },
        {
            no: 3,
            name: "read",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "skipped_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ExecutionScopeArtifactV1 is the structured extraction payload. Schema version
 * is frozen as execution-scope-artifact.v1.
 *
 * @generated from message mono.govcon.v1.ExecutionScopeArtifactV1
 */ export class ExecutionScopeArtifactV1 extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeArtifactV1().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeArtifactV1().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeArtifactV1().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeArtifactV1, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string schema_version = 1;
   */ _define_property(this, "schemaVersion", ""), /**
   * @generated from field: mono.govcon.v1.ExecutionScopeArtifactIdentity artifact_identity = 2;
   */ _define_property(this, "artifactIdentity", void 0), /**
   * @generated from field: repeated mono.govcon.v1.ExecutionScopeClaim claims = 3;
   */ _define_property(this, "claims", []), /**
   * @generated from field: repeated mono.govcon.v1.ExecutionScopeSourceReference source_references = 4;
   */ _define_property(this, "sourceReferences", []), /**
   * @generated from field: repeated mono.govcon.v1.ExecutionScopeSourceUnitCoverage source_unit_coverage = 5;
   */ _define_property(this, "sourceUnitCoverage", []), /**
   * @generated from field: repeated mono.govcon.v1.ExecutionScopeExtractionIssue issues = 6;
   */ _define_property(this, "issues", []), /**
   * @generated from field: mono.govcon.v1.ExecutionScopeExtractionSummary summary = 7;
   */ _define_property(this, "summary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeArtifactV1, "runtime", proto3);
_define_property(ExecutionScopeArtifactV1, "typeName", "mono.govcon.v1.ExecutionScopeArtifactV1");
_define_property(ExecutionScopeArtifactV1, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "schema_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_identity",
            kind: "message",
            T: ExecutionScopeArtifactIdentity
        },
        {
            no: 3,
            name: "claims",
            kind: "message",
            T: ExecutionScopeClaim,
            repeated: true
        },
        {
            no: 4,
            name: "source_references",
            kind: "message",
            T: ExecutionScopeSourceReference,
            repeated: true
        },
        {
            no: 5,
            name: "source_unit_coverage",
            kind: "message",
            T: ExecutionScopeSourceUnitCoverage,
            repeated: true
        },
        {
            no: 6,
            name: "issues",
            kind: "message",
            T: ExecutionScopeExtractionIssue,
            repeated: true
        },
        {
            no: 7,
            name: "summary",
            kind: "message",
            T: ExecutionScopeExtractionSummary
        }
    ]));
/**
 * ExecutionScopeArtifactIdentity identifies the immutable artifact version.
 *
 * @generated from message mono.govcon.v1.ExecutionScopeArtifactIdentity
 */ export class ExecutionScopeArtifactIdentity extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeArtifactIdentity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeArtifactIdentity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeArtifactIdentity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeArtifactIdentity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string artifact_version_id = 2;
   */ _define_property(this, "artifactVersionId", ""), /**
   * @generated from field: string content_sha256 = 3;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string rendition_id = 4;
   */ _define_property(this, "renditionId", ""), /**
   * @generated from field: string filename = 5;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 6;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: string raw_document_kind = 7;
   */ _define_property(this, "rawDocumentKind", ""), /**
   * @generated from field: mono.common.v1.ExecutionArtifactKind normalized_document_kind = 8;
   */ _define_property(this, "normalizedDocumentKind", ExecutionArtifactKind.UNSPECIFIED), /**
   * @generated from field: string title = 9;
   */ _define_property(this, "title", ""), /**
   * @generated from field: repeated mono.govcon.v1.ExecutionScopeIdentifier contract_identifiers = 10;
   */ _define_property(this, "contractIdentifiers", []), /**
   * @generated from field: int32 page_count = 11;
   */ _define_property(this, "pageCount", 0), /**
   * @generated from field: string language = 12;
   */ _define_property(this, "language", ""), /**
   * @generated from field: mono.common.v1.ExecutionArtifactCompleteness completeness = 13;
   */ _define_property(this, "completeness", ExecutionArtifactCompleteness.UNSPECIFIED);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeArtifactIdentity, "runtime", proto3);
_define_property(ExecutionScopeArtifactIdentity, "typeName", "mono.govcon.v1.ExecutionScopeArtifactIdentity");
_define_property(ExecutionScopeArtifactIdentity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rendition_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "raw_document_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "normalized_document_kind",
            kind: "enum",
            T: proto3.getEnumType(ExecutionArtifactKind)
        },
        {
            no: 9,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "contract_identifiers",
            kind: "message",
            T: ExecutionScopeIdentifier,
            repeated: true
        },
        {
            no: 11,
            name: "page_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "language",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "completeness",
            kind: "enum",
            T: proto3.getEnumType(ExecutionArtifactCompleteness)
        }
    ]));
/**
 * ExecutionScopeIdentifier is a raw/normalized contract identifier claim.
 *
 * @generated from message mono.govcon.v1.ExecutionScopeIdentifier
 */ export class ExecutionScopeIdentifier extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeIdentifier().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeIdentifier().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeIdentifier().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeIdentifier, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.ExecutionIdentifierKind kind = 1;
   */ _define_property(this, "kind", ExecutionIdentifierKind.UNSPECIFIED), /**
   * @generated from field: string raw_value = 2;
   */ _define_property(this, "rawValue", ""), /**
   * @generated from field: string normalized_value = 3;
   */ _define_property(this, "normalizedValue", ""), /**
   * @generated from field: repeated string source_reference_ids = 4;
   */ _define_property(this, "sourceReferenceIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeIdentifier, "runtime", proto3);
_define_property(ExecutionScopeIdentifier, "typeName", "mono.govcon.v1.ExecutionScopeIdentifier");
_define_property(ExecutionScopeIdentifier, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(ExecutionIdentifierKind)
        },
        {
            no: 2,
            name: "raw_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "normalized_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * ExecutionScopeClaim is one source-backed proposal. payload is claim-type
 * specific (JSON-schema "payload": object) and is never authoritative.
 *
 * @generated from message mono.govcon.v1.ExecutionScopeClaim
 */ export class ExecutionScopeClaim extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeClaim().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeClaim().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeClaim().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeClaim, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string claim_id = 1;
   */ _define_property(this, "claimId", ""), /**
   * @generated from field: mono.common.v1.ExecutionClaimType claim_type = 2;
   */ _define_property(this, "claimType", ExecutionClaimType.UNSPECIFIED), /**
   * @generated from field: string subject_provisional_key = 3;
   */ _define_property(this, "subjectProvisionalKey", ""), /**
   * @generated from field: google.protobuf.Struct payload = 4;
   */ _define_property(this, "payload", void 0), /**
   * @generated from field: repeated string source_reference_ids = 5;
   */ _define_property(this, "sourceReferenceIds", []), /**
   * @generated from field: double confidence = 6;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: mono.common.v1.ExecutionEvidenceGrade evidence_grade = 7;
   */ _define_property(this, "evidenceGrade", ExecutionEvidenceGrade.UNSPECIFIED), /**
   * @generated from field: mono.common.v1.ExecutionReviewRequirement review_requirement = 8;
   */ _define_property(this, "reviewRequirement", ExecutionReviewRequirement.UNSPECIFIED), /**
   * @generated from field: repeated string warnings = 9;
   */ _define_property(this, "warnings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeClaim, "runtime", proto3);
_define_property(ExecutionScopeClaim, "typeName", "mono.govcon.v1.ExecutionScopeClaim");
_define_property(ExecutionScopeClaim, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "claim_type",
            kind: "enum",
            T: proto3.getEnumType(ExecutionClaimType)
        },
        {
            no: 3,
            name: "subject_provisional_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "payload",
            kind: "message",
            T: Struct
        },
        {
            no: 5,
            name: "source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "evidence_grade",
            kind: "enum",
            T: proto3.getEnumType(ExecutionEvidenceGrade)
        },
        {
            no: 8,
            name: "review_requirement",
            kind: "enum",
            T: proto3.getEnumType(ExecutionReviewRequirement)
        },
        {
            no: 9,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * ExecutionScopeSourceReference is extraction-time provenance, not a pangaea
 * row. Anchors retain block id, bbox, quote, and artifact version/hash.
 *
 * @generated from message mono.govcon.v1.ExecutionScopeSourceReference
 */ export class ExecutionScopeSourceReference extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeSourceReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeSourceReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeSourceReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeSourceReference, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string source_reference_id = 1;
   */ _define_property(this, "sourceReferenceId", ""), /**
   * @generated from field: string source_kind = 2;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string raw_value = 3;
   */ _define_property(this, "rawValue", ""), /**
   * @generated from field: string normalized_value = 4;
   */ _define_property(this, "normalizedValue", ""), /**
   * @generated from field: double confidence = 5;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: repeated string warnings = 6;
   */ _define_property(this, "warnings", []), /**
   * @generated from field: repeated mono.common.v1.ExecutionSourceAnchor anchors = 7;
   */ _define_property(this, "anchors", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeSourceReference, "runtime", proto3);
_define_property(ExecutionScopeSourceReference, "typeName", "mono.govcon.v1.ExecutionScopeSourceReference");
_define_property(ExecutionScopeSourceReference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "raw_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "normalized_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "anchors",
            kind: "message",
            T: ExecutionSourceAnchor,
            repeated: true
        }
    ]));
/**
 * ExecutionScopeSourceUnitCoverage accounts for every input block/unit.
 *
 * @generated from message mono.govcon.v1.ExecutionScopeSourceUnitCoverage
 */ export class ExecutionScopeSourceUnitCoverage extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeSourceUnitCoverage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeSourceUnitCoverage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeSourceUnitCoverage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeSourceUnitCoverage, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string unit_id = 1;
   */ _define_property(this, "unitId", ""), /**
   * @generated from field: repeated string block_ids = 2;
   */ _define_property(this, "blockIds", []), /**
   * @generated from field: int32 page_number = 3;
   */ _define_property(this, "pageNumber", 0), /**
   * @generated from field: mono.common.v1.ExecutionSourceUnitCoverageState state = 4;
   */ _define_property(this, "state", ExecutionSourceUnitCoverageState.UNSPECIFIED), /**
   * @generated from field: repeated string produced_claim_ids = 5;
   */ _define_property(this, "producedClaimIds", []), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: repeated string warnings = 7;
   */ _define_property(this, "warnings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeSourceUnitCoverage, "runtime", proto3);
_define_property(ExecutionScopeSourceUnitCoverage, "typeName", "mono.govcon.v1.ExecutionScopeSourceUnitCoverage");
_define_property(ExecutionScopeSourceUnitCoverage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "block_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "state",
            kind: "enum",
            T: proto3.getEnumType(ExecutionSourceUnitCoverageState)
        },
        {
            no: 5,
            name: "produced_claim_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * ExecutionScopeExtractionIssue is a non-fatal or blocking extractor finding.
 *
 * @generated from message mono.govcon.v1.ExecutionScopeExtractionIssue
 */ export class ExecutionScopeExtractionIssue extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeExtractionIssue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeExtractionIssue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeExtractionIssue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeExtractionIssue, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string code = 1;
   */ _define_property(this, "code", ""), /**
   * @generated from field: mono.common.v1.ExecutionIssueSeverity severity = 2;
   */ _define_property(this, "severity", ExecutionIssueSeverity.UNSPECIFIED), /**
   * @generated from field: string message = 3;
   */ _define_property(this, "message", ""), /**
   * @generated from field: repeated string claim_ids = 4;
   */ _define_property(this, "claimIds", []), /**
   * @generated from field: repeated string source_reference_ids = 5;
   */ _define_property(this, "sourceReferenceIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeExtractionIssue, "runtime", proto3);
_define_property(ExecutionScopeExtractionIssue, "typeName", "mono.govcon.v1.ExecutionScopeExtractionIssue");
_define_property(ExecutionScopeExtractionIssue, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "severity",
            kind: "enum",
            T: proto3.getEnumType(ExecutionIssueSeverity)
        },
        {
            no: 3,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "claim_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * ExecutionScopeExtractionSummary is extractor telemetry, not user-visible truth.
 *
 * @generated from message mono.govcon.v1.ExecutionScopeExtractionSummary
 */ export class ExecutionScopeExtractionSummary extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeExtractionSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeExtractionSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeExtractionSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeExtractionSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.ExecutionExtractionStatus status = 1;
   */ _define_property(this, "status", ExecutionExtractionStatus.UNSPECIFIED), /**
   * @generated from field: string extractor_name = 2;
   */ _define_property(this, "extractorName", ""), /**
   * @generated from field: string extractor_version = 3;
   */ _define_property(this, "extractorVersion", ""), /**
   * @generated from field: string model_provider = 4;
   */ _define_property(this, "modelProvider", ""), /**
   * @generated from field: string model_name = 5;
   */ _define_property(this, "modelName", ""), /**
   * @generated from field: int32 source_unit_count = 6;
   */ _define_property(this, "sourceUnitCount", 0), /**
   * @generated from field: int32 claim_count = 7;
   */ _define_property(this, "claimCount", 0), /**
   * @generated from field: int32 unresolved_unit_count = 8;
   */ _define_property(this, "unresolvedUnitCount", 0), /**
   * @generated from field: int32 failed_unit_count = 9;
   */ _define_property(this, "failedUnitCount", 0), /**
   * @generated from field: int64 duration_ms = 10;
   */ _define_property(this, "durationMs", protoInt64.zero), /**
   * @generated from field: int64 input_tokens = 11;
   */ _define_property(this, "inputTokens", protoInt64.zero), /**
   * @generated from field: int64 output_tokens = 12;
   */ _define_property(this, "outputTokens", protoInt64.zero), /**
   * @generated from field: double estimated_cost_usd = 13;
   */ _define_property(this, "estimatedCostUsd", 0), /**
   * @generated from field: repeated string warnings = 14;
   */ _define_property(this, "warnings", []), /**
   * @generated from field: google.protobuf.Timestamp extracted_at = 15;
   */ _define_property(this, "extractedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeExtractionSummary, "runtime", proto3);
_define_property(ExecutionScopeExtractionSummary, "typeName", "mono.govcon.v1.ExecutionScopeExtractionSummary");
_define_property(ExecutionScopeExtractionSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "enum",
            T: proto3.getEnumType(ExecutionExtractionStatus)
        },
        {
            no: 2,
            name: "extractor_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "extractor_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "model_provider",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "model_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_unit_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "claim_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "unresolved_unit_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "failed_unit_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "duration_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 11,
            name: "input_tokens",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 12,
            name: "output_tokens",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 13,
            name: "estimated_cost_usd",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 14,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 15,
            name: "extracted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
